import TEXT_APP_INFO from 'constants/appInfo';
import { Text } from 'components';

const renderTable = (tableData: {
  headers: string[];
  rows: { columns: string[] }[];
}) => {
  return (
    <table className="min-w-full border-collapse border border-gray-300 my-4">
      <thead>
        <tr className="bg-gray-100">
          {tableData.headers.map((header, hIdx) => (
            <th key={hIdx} className="px-2 py-1 border border-gray-200">
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {tableData.rows.map((row, rIdx) => {
          const bgColor = rIdx % 2 === 0 ? 'bg-white' : 'bg-gray-50';
          return (
            <tr key={rIdx} className={bgColor}>
              {row.columns.map((col, cIdx) => (
                <td key={cIdx} className="px-2 py-1 border border-gray-200">
                  {col}
                </td>
              ))}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

function About() {
  return (
    <div className="h-full overflow-y-auto">
      <article className="mx-auto p-3">
        <div className="space-y-6">
          {TEXT_APP_INFO.ABOUT.map((item, index) => {
            return (
              <div key={index}>
                {item.text && (
                  <Text bold className="text-base leading-7 mt-4">
                    {item.text}
                  </Text>
                )}

                {item.content && (
                  <Text className="text-sm mt-2">
                    <div dangerouslySetInnerHTML={{ __html: item.content }} />
                  </Text>
                )}

                {item.table && renderTable(item.table)}
              </div>
            );
          })}
        </div>
      </article>
    </div>
  );
}

export default About;
